import { render, staticRenderFns } from "./UniteColonies.vue?vue&type=template&id=cd24b9a6&scoped=true&"
import script from "./UniteColonies.vue?vue&type=script&lang=js&"
export * from "./UniteColonies.vue?vue&type=script&lang=js&"
import style0 from "./UniteColonies.vue?vue&type=style&index=0&id=cd24b9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd24b9a6",
  null
  
)

export default component.exports